export interface CookieDataModel {
    SyncGatewaySession?: string,
    Authorization?: string,
    IdToken?: string
}

export class CookieData {
    static create (model: CookieDataModel): CookieData {
        const {
            SyncGatewaySession,
            Authorization,
            IdToken
        } = model;

        return new CookieData(SyncGatewaySession, Authorization, IdToken);
    }

    static createFromSerializedData(serializedData: string): CookieData | undefined {
        try {
            const data = JSON.parse(serializedData);
            const {
                SyncGatewaySession,
                Authorization,
                IdToken
            } = data;
            return new CookieData(SyncGatewaySession, Authorization, IdToken);
        } catch(error) {
            return;
        }
    }

    constructor (
        public readonly SyncGatewaySession?: string,
        public readonly Authorization?: string,
        public readonly IdToken?: string
    ){}

    public serialize (): string {
        return JSON.stringify(this);
    }
}